// PDP Tech-icon script
const initPDPTechIcons = function() {
  let pdp_icon_arr = document.querySelectorAll('.tech-icon-section-icon-wrappers');
  let has_icons = document.querySelectorAll('.tech-icons');

  const toggleHiddenIcons = (arrayList) => {
    arrayList.forEach(function(el, index) {
      arrayList[index].classList.toggle('hide-extra-pdp-icons');

      let icons_hidden = document.querySelectorAll('.hide-extra-pdp-icons');
      let see_more_text = (icons_hidden.length == 0) ? 'See Less' : 'See More';

      document.getElementById('tech-icon-show-more').innerHTML = see_more_text;
    })
  }

  if (window.innerWidth < 990) {
    if (pdp_icon_arr.length != 0 && pdp_icon_arr.length > 4) {
      for (let i = 5; i <= pdp_icon_arr.length; i++) {
        document.getElementById(`pdp-icon-${i}`).classList.add('hide-extra-pdp-icons');
      }

      let hidden_icons = document.querySelectorAll('.hide-extra-pdp-icons');

      document.getElementById(`pdp-icon-${pdp_icon_arr.length}`).insertAdjacentHTML('afterend', '<span id="tech-icon-show-more" class="tech-icon-section-icon-wrappers">See More</span>');
      document.getElementById('tech-icon-show-more').addEventListener('click', () => toggleHiddenIcons(hidden_icons));
    }
  }

  if (has_icons.length == 0 || has_icons == undefined || has_icons == null) {
    document.querySelector('.tech-icon-section-container').style.display = 'none';
  }

  document.addEventListener('section:load', initPDPTechIcons);
}
// 